<template>
	<span class="text-navy-blue-01 leading-none text-4xl xl:text-heading font-canela font-light mb-3 whitespace-nowrap" v-observe-visibility="onVisibilityChange">{{ display }}</span>
</template>

<script>
export default {
	props: {
		value: { type: [Number, String], required: true },
		duration: { type: Number, default: 2000 },
	},
	data() {
		return {
			display: 0,
			hasAnimated: false,
		};
	},
	methods: {
		startCount() {
			if (this.hasAnimated) return;
			this.hasAnimated = true;

			const match = this.value.toString().match(/^(\d[\d,]*)\s*(.*)$/);
			if (!match) return;
			const num = parseInt(match[1].replace(/,/g, ""), 10);
			const suffix = match[2] ? " " + match[2] : "";
			if (isNaN(num)) return;

			let frame = 0;
			const frameRate = 1000 / 60;
			const totalFrames = Math.round(this.duration / frameRate);
			clearInterval(this._counter);

			this._counter = setInterval(() => {
				frame++;
				const progress = frame / totalFrames;
				this.display =
					Math.floor(num * progress).toLocaleString() +
					(frame >= totalFrames ? suffix : "");
				if (frame >= totalFrames) {
					clearInterval(this._counter);
					this.display = num.toLocaleString() + suffix;
				}
			}, frameRate);
		},
		onVisibilityChange(isVisible) {
			if (isVisible) this.startCount();
		},
	},
};
</script>
